import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { buildUrlAndOpenSameWindow, prepareUrl } from '../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../Config';
import EpiContext from '@episerver/spa-core/Spa';

const WizardList = (props) => {

    //console.info('props.iContent.wizardList', props.iContent.wizardList);

    useEffect(() => {

    }, []);

    return (
        <div className='wizard-list-wrapper'>
            <div className='wizard-list'>
                {
                    props.iContent.wizardList?.expandedValue?.map((item, index) => {
                        return (
                            <div key={index} className='wizard-item'>
                                {
                                    item.icon?.expandedValue &&
                                    <div className='icon-wrapper'> <Image src={Config.epiBaseUrl + item.icon?.expandedValue?.url} /> </div>
                                }

                                <div className='title-wrapper'>
                                    <div className='title'>
                                        {item.title?.value}

                                        {
                                            item.tagText?.value &&
                                            <div className='wizard-tag-wrapper'>
                                                <div className='wizard-tag' style={{ backgroundColor: item.tagBackgroundColor?.value, color: item.tagTextColor?.value }}> {item.tagText?.value} </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className='text-wrapper' dangerouslySetInnerHTML={{ __html: item.text?.value }}></div>
                                {
                                    item.linkText?.value &&
                                    <div className='wizard-link'>
                                        <a href='#' onClick={(e) => handleOnClick(e, item.link?.value)}> {item.linkText?.value + ' >'} </a>
                                    </div>
                                }
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );

    function handleOnClick(e, link) {
        e.preventDefault();
        prepareUrl(link, EpiContext);
    }

};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(WizardList);
